import React from 'react';
import PropTypes from 'prop-types';
import { BootstrapModal } from 'shared-components/modal/bootstrap-modal';

export class ErrorModal extends React.Component {
  constructor (props) {
    super(props);

    this.closeModal = this.closeModal.bind(this);
  }

  closeModal (redirect) {
    const { errorModalProps, toggleModal } = this.props;
    const { onClick, clickArgs } = errorModalProps;
    onClick(clickArgs, redirect);
    return toggleModal('');
  }

  render () {
    const { errorModalProps } = this.props;
    const { errorMessage, CTAtext } = errorModalProps;
    return (
      <BootstrapModal
        {...this.props}
        onClose={this.closeModal}
        modalClass="error-modal"
        header={
          <h3>{ errorMessage }</h3>
        }
        body={
          <div className="container-fluid text-center">
            <div className="row">
              <div className="col-xs-10 col-xs-offset-1">
                <div className="text-gray-dark">
                </div>
                <button className="btn btn-block btn-primary form" onClick={ () => this.closeModal(true) } style={ { marginBottom: '24px' } }>
                  { CTAtext }
                </button>
              </div>
            </div>
          </div>
        }
      />
    )
  }
}


ErrorModal.propTypes = {
  toggleModal: PropTypes.func,  // from app-main/containers/App
  errorMessage: PropTypes.string,
  CTAtext: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object // JSX compiled
  ]),
  onClick: PropTypes.func,
  clickArgs: PropTypes.array // this array should hold a secondary callback and it's arguments that your CB needs
};
